import axios from 'axios';
import { AcceptedTermsData, ApiResponse, SessionWithBstInfo, VerifyPatientBirthDate } from '../../ts';

interface RegisterParams {
  mobile: string;
  password: string;
  smsCode: string;
  verifyPatientBirthDate?: VerifyPatientBirthDate;
  acceptedTermsData?: AcceptedTermsData;
}

export const signupService = async ({mobile, password, smsCode, verifyPatientBirthDate, acceptedTermsData}: RegisterParams) => {
  let response: ApiResponse<SessionWithBstInfo>;

  try {
    const axiosResponse = await axios.post<ApiResponse<SessionWithBstInfo>>('/users/register', {
      mobile,
      password,
      code: smsCode,
      verifyPatientBirthDate,
      acceptedTermsData
    });

    response = axiosResponse.data;
  } catch (error: any) {
    throw new Error('errors.unexpectedError');
  }

  if (response.isOk === false) {
    if (response.message.toLowerCase() === 'mobile already registered') {
      throw new Error('modal.verifyMobile.errors.mobileAlreadyRegistered');
    }

    if (response.message.toLowerCase() === 'invalid sms code') {
      throw new Error('modal.verifyMobile.errors.invalidSmsCode');
    }

    if (response.message.toLowerCase() === 'invalid bst') {
      throw new Error('pages.login-signup.bstNotValid');
    }

    throw new Error('errors.unexpectedError');
  }

  return response.data;
};
